import { Directive, HostBinding } from '@angular/core';
import { NgModel } from '@angular/forms';
import { listTitleStyles } from '@kite_aerolab/shared/components';

@Directive({
  selector: '[listTitle]',
  providers: [NgModel],
})
export class ListTitleDirective {

  @HostBinding('class')
  public get setClasses() {
    return listTitleStyles({
    }).className;
  }
}
